import $ from 'jquery';
import PubSub from 'pubsub-js';
var InkModal = function(){

  var modalTrigger = $('.js-ink-modal-trigger'),
    transitionLayer = $('.js-ink-modal-transition'),
    transitionBackground = transitionLayer.children(),
    modalWindow = $('.js-ink-modal'),
    $html = $('html');

  var frameProportion = 1.78, //png frame aspect ratio
    frames = 25, //number of png frames
    resize = false;

  function init() {

    // Listen to scroll to and open at when navigating to about
    PubSub.subscribe('afterScrollToDestination', function(msg, data){
      if( data === "about-us" ) {
        modalTrigger.trigger('click');
      }
    });

    setLayerDimensions();
    $(window).on('resize', function(){
      if( !resize ) {
        resize = true;
        (!window.requestAnimationFrame) ? setTimeout(setLayerDimensions, 300) : window.requestAnimationFrame(setLayerDimensions);
      }
    });

    //open modal window
    modalTrigger.on('click', function(event){
      event.preventDefault();
      transitionLayer.addClass('visible opening');
      var delay = ( $('.no-cssanimations').length > 0 ) ? 0 : 600;
      modalWindow.show();
      setTimeout(function(){
        modalWindow.addClass('visible');
        $html.addClass('is-modal');
        PubSub.publish('modalopen');
      }, delay);
    });

    //close modal window
    modalWindow.on('click', '.js-close', function(event){
      event.preventDefault();
      transitionLayer.addClass('closing');
      modalWindow.removeClass('visible');
      transitionBackground.one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function(){
        transitionLayer.removeClass('closing opening visible');
        $html.removeClass('is-modal');
        transitionBackground.off('webkitAnimationEnd oanimationend msAnimationEnd animationend');
        modalWindow.hide();
        PubSub.publish('modalclose');
      });
    });

  }

  function setLayerDimensions() {
    var windowWidth = $(window).width(),
      windowHeight = $(window).height(),
      layerHeight, layerWidth;

    if( windowWidth/windowHeight > frameProportion ) {
      layerWidth = windowWidth;
      layerHeight = layerWidth/frameProportion;
    } else {
      layerHeight = windowHeight*1.2;
      layerWidth = layerHeight*frameProportion;
    }

    transitionBackground.css({
      'width': layerWidth*frames+'px',
      'height': layerHeight+'px',
    });

    resize = false;
  }

  init();

}

export default InkModal();